import { Link } from '../../app/models/link';
import { UrlHelper } from '../../app/utils/url';

export class UrlWhitelist {

    static whitelist: Array<string> = [
        'digi.schule',
        'digi.study',
        'digischule.at',
        'esquirrel.at',
        'mathe-trainer.com',
        'eduvidual.at',
        'sia.education',
        'areeka.net',
        'studio.areeka.net',
        'mbook.at',
        'mbook.education',
        'mbook.at',
        'mein.lemberger.at',
        'bildungsverlag-lemberger.at',
        'lemberger.at',
        'digbi.net',
        'mathion.ai',
        'mathegym.at',
        'mathegym.de',
        'mathe4alle.at',
        'bildung4alle.at',
        'lemberger.eduhint.nl'
    ];

    static isOnWhiteList(link: Link | string): boolean {
        let urlToCheck: string;
        if (link instanceof Link) {
            urlToCheck = link.url;
        } else {
            urlToCheck = link;
        }

        if (!urlToCheck) {
            return false;
        }

        if (UrlHelper.isSameDomain(urlToCheck, window.location.href)) {
            return true;
        }

        for (const currUrl of UrlWhitelist.whitelist) {
            if (UrlHelper.isSameDomain(urlToCheck, currUrl)) {
                return true;
            }
        }

        return false;
    }
}
